import React from 'react'
import { withGridContext } from '../providers'
import CellHeaderRender from '../cell-header-render'
import { ContextType } from '../types/advanced-grid.types'
import { CheckBoxField } from '@app-soga/forms'

/**
 * Renders the header wrapper and header cells for the table
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @param param0
 * @returns
 */
const TableHeader: React.FC<ContextType> = ({
    actions,
    gridId,
    columns,
    config,
    dataLoaded,
    events,
    rowControl,
    rowControlOptions,
    selectAllCheck,
    sorts
}) => {
    const { allowSelect } = config || {}
    const { handleSelectAll, handleChangeSort } = events || {}
    const { title: rowControlTitle } = rowControlOptions || {}
    return (
        <>
            {dataLoaded && (
                <>
                    <thead>
                        <tr>
                            {Boolean(rowControl) && (
                                <th
                                    className={`${
                                        rowControlOptions ? rowControlOptions.className : ''
                                    }`}
                                >
                                    {rowControlTitle}
                                </th>
                            )}
                            {allowSelect && (
                                <th className="width-10">
                                    <CheckBoxField
                                        checked={selectAllCheck}
                                        id={`${gridId}-chk-select-all`}
                                        onChange={() => {
                                            if (handleSelectAll) {
                                                handleSelectAll()
                                            }
                                        }}
                                    />
                                </th>
                            )}
                            <th className="width-20">ID</th>
                            {columns &&
                                columns.map((item, key) => (
                                    <CellHeaderRender
                                        key={`key-${key}`}
                                        handleSortChange={handleChangeSort}
                                        header={item}
                                        sorts={sorts}
                                    />
                                ))}
                            {actions && actions?.length > 0 && (
                                <th className="text-center w-12">Actions</th>
                            )}
                        </tr>
                    </thead>
                </>
            )}
        </>
    )
}

export default withGridContext(TableHeader)
